export default __webpack_public_path__ + "static/carousel_dark-d1d12aea7d9d85a8a5fc26cb332fa4c8.gif";